import { Injectable } from "@angular/core";
import { AlertController, ModalController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { ChecklistProgressStateService } from "../state/checklist-progress-state.service";
import { ChecklistModalComponent } from "./checklist-modal.component";
import { ApiService } from "source/app/configuration/services/api.service";
import { UnsupportedQuestionsService } from "../services/unsupported-questions.service";
import { UnsupportedElementsCheckResult } from "../services/unsupported-questions.service";
import { LocationActivity } from "../checklist.interface";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Injectable()
export class ChecklistModalService {
	constructor(
		private modalController: ModalController,
		private alertController: AlertController,
		private translocoService: TranslocoService,
		private unsupportedQuestionsService: UnsupportedQuestionsService,
		private checklistProgressService: ChecklistProgressStateService,
		private apiService: ApiService,
		private rideOpsUi: RideOpsUiService,
	) {}

	async show(activity: LocationActivity): Promise<boolean> {
		const checklist = await this.apiService.getChecklist(activity);

		if (checklist.pages.length === 0) {
			await this.showEmptyChecklistAlert();
			return false;
		}

		const unsupportedQuestionsCheckResult =
			await this.unsupportedQuestionsService.checkForUnsupportedQuestions(checklist);

		if (unsupportedQuestionsCheckResult !== UnsupportedElementsCheckResult.Continue) {
			return false;
		}

		await this.checklistProgressService.setActiveChecklist(checklist, activity);

		const modal = await this.modalController.create({
			cssClass: this.rideOpsUi.isV2Active() ? "checklist-modal checklist-modal-v2" : "checklist-modal",
			component: ChecklistModalComponent,
		});

		await modal.present();
		const result = await modal.onDidDismiss();

		if (result.data === ChecklistModalComponent.returnCodes.noContent) {
			await this.showEmptyChecklistAlert();
			return false;
		}

		return result.data === ChecklistModalComponent.returnCodes.submitted;
	}

	private showEmptyChecklistAlert = async (): Promise<void> => {
		const alert = await this.alertController.create({
			header: this.translocoService.translate("CHECKLIST_NO_PAGES_TITLE"),
			message: this.translocoService.translate("CHECKLIST_NO_PAGES_MESSAGE"),
			buttons: [this.translocoService.translate("CHECKLIST_NO_PAGES_OK")],
			backdropDismiss: false,
			cssClass: this.rideOpsUi.isV2Active() ? "operators-v2-dialog" : undefined,
		});
		await alert.present();
		await alert.onDidDismiss();
	};
}
